import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    pollUrl: String,
    results: Object,
    fields: Array
  }

  connect() {
    // Poll for live updates every 5 seconds
    if (this.hasPollUrlValue && this.pollUrlValue !== "#") {
      this.pollInterval = setInterval(() => this.fetchResults(), 5000)
    }
  }

  disconnect() {
    if (this.pollInterval) clearInterval(this.pollInterval)
  }

  async fetchResults() {
    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.pollUrlValue, {
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": token
        }
      })

      if (!response.ok) return
      const data = await response.json()
      if (!data.poll_results) return

      // Update bar widths and counts
      Object.entries(data.poll_results).forEach(([fieldId, result]) => {
        const fieldContainer = this.element.querySelector(`[data-renderer-field-id="${fieldId}"]`) ||
                               this.element
        if (!fieldContainer) return

        const bars = fieldContainer.querySelectorAll("[data-poll-option]")
        if (bars.length === 0) {
          // Fallback: update by matching percentage bars
          this.updateBarsFromContent(fieldContainer, result)
        }
      })
    } catch (err) {
      console.error("Poll results fetch error:", err)
    }
  }

  updateBarsFromContent(container, result) {
    const progressBars = container.querySelectorAll(".bg-brand-500.rounded-full")
    const countSpans = container.querySelectorAll(".text-gray-500")

    result.options.forEach((opt, idx) => {
      const pct = result.total_votes > 0 ? ((opt.count / result.total_votes) * 100).toFixed(1) : 0
      if (progressBars[idx]) {
        progressBars[idx].style.width = `${pct}%`
      }
    })
  }
}
